package com.arena_web.ui.localization

import androidx.compose.runtime.staticCompositionLocalOf

enum class Language(val code: String, val nativeName: String, val strings: AppStrings) {
    ENGLISH("en", "English", AppStringsEN),
    UKRAINIAN("ua", "Українська", AppStringsUA),
    SPANISH("es", "Español", AppStringsES),
    GERMAN("de", "Deutsch", AppStringsDE),
    FRENCH("fr", "Français", AppStringsFR),
    PORTUGUESE("pt", "Português", AppStringsPT),
    ITALIAN("it", "Italiano", AppStringsIT),
    POLISH("pl", "Polski", AppStringsPL);

    companion object {
        fun fromCode(code: String?): Language =
            entries.find { it.code == code } ?: ENGLISH

        /** Maps a BCP-47 browser tag ("uk", "pt-BR", …) to a supported language. */
        fun fromBrowserTag(tag: String?): Language? {
            val t = tag?.lowercase() ?: return null
            // Storage code "ua" predates this mapping; browsers report Ukrainian as "uk".
            if (t == "uk" || t.startsWith("uk-")) return UKRAINIAN
            return entries.find { t == it.code || t.startsWith("${it.code}-") }
        }
    }
}

val LocalAppStrings = staticCompositionLocalOf<AppStrings> { AppStringsEN }
